import script from "./GroupRadioBox.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupRadioBox.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__